// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"72d6b7ce","280":"cb350e8a","323":"8656f1a2","342":"06e2834b","355":"e382dc3b","731":"3b631681"}[chunkId] + ".js";
};